module.exports = __webpack_public_path__ + "img/icon_fail.1abe2912.png";